import { PHONE as FIRST_CALL_PHONE } from "constants/at-need";

/** The pre-need sales and support line. */
export const SUPPORT_PHONE_HREF = "tel:8444311320";
export const SUPPORT_PHONE_LABEL = "(844) 431-1320";

/** The At-Need first-call line, answered around the clock. */
export const FIRST_CALL_PHONE_HREF = `tel:${FIRST_CALL_PHONE}`;
export const FIRST_CALL_PHONE_LABEL = "(844) 905-2639";

/** The Care Team line the quiz's dead-end screen offers: after-www's
 * `hospice` phone key. Distinct from the numbers above. */
export const CARE_TEAM_PHONE_HREF = "tel:8449835190";
export const CARE_TEAM_PHONE_LABEL = "(844) 983-5190";
